import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'react-perfect-scrollbar/dist/css/styles.css'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import 'react-quill/dist/quill.snow.css'
import 'prismjs/prism'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-jsx'
import 'nprogress/nprogress.css'
// import 'src/__mocks__';
import 'src/assets/css/prism.css'
import 'src/mixins/chartjs'

import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { enableES5 } from 'immer'
import * as serviceWorker from 'src/serviceWorker'
import store from 'src/store'
import { SettingsProvider } from 'src/contexts/SettingsContext'
import App from 'src/App'
import defaultOptionsReactQuery from './utils/defaultOptionsReactQuery'

const queryClient = new QueryClient(defaultOptionsReactQuery)
enableES5()

ReactDOM.render(
  <Provider store={store}>
    <SettingsProvider>
      <QueryClientProvider client={queryClient}>
        <App />
        <div
          hidden
          className="release_test_62_24.08"
          aria-label="Release notes"
        />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </SettingsProvider>
  </Provider>,
  document.getElementById('root')
)

serviceWorker.register()
